<ejs-dialog class="modal rounded" *ngIf="dialogVisible" id="dialog" #ejDialog [isModal]="true" width="90%" height="100%"
  [visible]="dialogVisible">
  <button (click)="onOverlayClick()" type="button" class="close" aria-label="Close"><span
      aria-hidden="true">&times;</span></button>
  <app-pu-accordian *ngIf="fieldData" [data]="fieldData" [headerField]="headerData"></app-pu-accordian>
</ejs-dialog>